import { BaseController } from '../../base/controller';

class PositionsController extends BaseController {
  constructor(controllerService, $scope) {
    'ngInject';
    super({ controllerService, $scope });
  }

  $onInit() {
    this.transferPositions = {};
    this.show = false;
  }

  toggle() {
    this.show = !this.show;
  }
}

export default PositionsController;



// WEBPACK FOOTER //
// ./src/app/common/ui/positions/positions.controller.js